export default __webpack_public_path__ + "combobox.7be70b23.svg";